function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Image, Link } from "@labs/schema";
import { motion, useReducedMotion } from "framer-motion";
import React, { useEffect, useRef } from "react";
import { useIntl } from "../../utils/intl";
export default function TeaserListItem(param) {
    var link = param.link, image = param.image, title = param.title, date = param.date, topics = param.topics, icon = param.icon, priority = param.priority, isFirstNewItem = param.isFirstNewItem, hasLoadedMore = param.hasLoadedMore;
    var wrapperRef = useRef(null);
    useEffect(function() {
        if (hasLoadedMore && isFirstNewItem && wrapperRef.current) {
            // Only focus if it's the first new item and "Load More" was clicked
            var anchorElement = wrapperRef.current.querySelector("a");
            if (anchorElement) {
                anchorElement.focus();
            }
        }
    }, [
        isFirstNewItem,
        hasLoadedMore
    ]);
    var intl = useIntl();
    var reduceMotion = useReducedMotion() || priority;
    var animationInitial = reduceMotion ? {} : {
        opacity: 0,
        y: 50
    };
    var animationWhileInView = reduceMotion ? {} : {
        opacity: 1,
        y: 0
    };
    return /*#__PURE__*/ React.createElement(motion.div, {
        transition: {
            duration: 0.8
        },
        initial: animationInitial,
        whileInView: animationWhileInView,
        className: "md:even:mt-[55px] relative group"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-[1/2] overflow-hidden relative"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, image ? /*#__PURE__*/ React.createElement(Image, _extends({}, image, {
        className: "motion-safe:group-hover:scale-103 transform-gpu duration-300 w-full",
        alt: "",
        priority: priority
    })) : null, icon ? /*#__PURE__*/ React.createElement("div", {
        className: "absolute inset-0 w-full h-full"
    }, /*#__PURE__*/ React.createElement(Image, _extends({}, icon, {
        className: "absolute block mx-auto bottom-[40px] w-auto lg:bottom-[90px] !max-w-[60%] md:!max-w-[50%] inset-x-0",
        alt: "",
        priority: priority
    }))) : null)), /*#__PURE__*/ React.createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ React.createElement(Link, {
        href: link,
        className: "after:absolute after:inset-0 block text-black h4 !mb-0 mt-4 group-hover:text-purple"
    }, title)), date ? /*#__PURE__*/ React.createElement("div", {
        className: "text-xs leading-xxs font-medium inline-block mr-4"
    }, intl.formatDate(date, {
        year: "numeric",
        month: "short",
        day: "numeric"
    })) : null, topics ? /*#__PURE__*/ React.createElement("div", {
        className: "text-black inline-block text-xs leading-[0]"
    }, topics.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("span", {
            className: "inline-block text-xs leading-xxs text-turquoise-500 font-medium mr-1 relative after:content-['\\002C'] after:inline-block last:after:content-[''] after:leading-[0]",
            key: index
        }, item);
    })) : null);
}
